import { CHAT_HUB_ID } from "@/config/constants";
import { ChatType } from "@/server/types/chat";

/**
 * Is this chat a conversation with ORION Architect?
 *
 * There is no dedicated ChatType for it — an Architect chat is an ordinary
 * GROUP chat whose `hubId` is the deployment's OA hub. This expression is the
 * client's entire notion of "this is an Architect chat"; it is also inlined in
 * ChatPlayground, ChatPlaygroundHeader, ChatListEntry and EditChatDetails.
 *
 * Pure on purpose — callers pass the two values in. That keeps it free of any
 * store dependency, so middleware, Zustand actions and components can all use
 * it, and it cannot introduce an import cycle through NavigationState.
 */
export function isArchitectChat(
  type: ChatType | null | undefined,
  hubId: string | null | undefined,
): boolean {
  return type === ChatType.GROUP && hubId === CHAT_HUB_ID;
}
